// The texts of the agent Reports screens (redesign step 4, step B), English and Italian. Merged into en.js and it.js.

export const reportsAgentEn = {
  'reports.title': 'Reports',
  'reports.card.commissions': 'Commissions',
  'reports.card.discrepancies': 'Discrepancies',
  'reports.card.forecast': 'Commission forecast',
  'reports.card.suppliers': 'Suppliers',
  'reports.card.customers': 'Customers',
  'reports.card.archive': 'Archive',
  'reports.back': 'Back',
  'reports.loading': 'Loading…',
  'reports.error': 'This report can\'t be loaded right now.',
  'reports.retry': 'Try again',
  'reports.notAgent': 'These reports are for agent companies.',
  'reports.period.this_week': 'This week',
  'reports.period.this_month': 'This month',
  'reports.period.this_year': 'This year',
  'reports.period.custom': 'Custom',
  'reports.period.next_week': 'Next week',
  'reports.period.next_month': 'Next month',
  'reports.period.next_6_months': 'Next 6 months',
  'reports.period.from': 'From',
  'reports.period.to': 'To',
  'reports.period.apply': 'Apply',
  'reports.period.bad': 'Choose a start before the end.',
  'reports.week': 'Week {n}',
  'reports.byCompany': 'By company',
  'reports.col.company': 'Company',
  'reports.col.share': 'Share',
  'reports.col.rate': 'Rate',
  'reports.col.netInvoiced': 'Net invoiced',
  'reports.col.netExpected': 'Net expected',
  'reports.col.commission': 'Commission',
  'reports.col.expected': 'Expected commission',
  'reports.total': 'Total',
  'reports.none': '—',
  'reports.noSupplier': 'No supplier identified',
  'reports.others': 'Others ({n})',
  'reports.showAll': 'Show all {n} companies',
  'reports.showFewer': 'Show fewer',
  'reports.commission.note': 'Counted when the payment term ends, so it can differ from this period\'s invoiced amount.',
  'reports.disc.casesCol': 'cases',
  'reports.empty': 'Nothing in this period.',
  'reports.rateConflict': 'Two different rates',
  'reports.excludingNoRate.one': 'excluding 1 supplier without a rate',
  'reports.excludingNoRate.many': 'excluding {n} suppliers without a rate',
  'reports.statement.title': 'Commission statement',
  'reports.statement.export': 'Export statement',
  'reports.statement.hint': 'One PDF for this company, to send to the supplier to get paid',
  'reports.statement.failed': 'The statement could not be made. Try again.',
  'reports.chart.by.day': 'By day',
  'reports.chart.by.week': 'By week',
  'reports.chart.by.month': 'By month',
  'reports.stmt.card': 'Upload statement',
  'reports.stmt.cardHint': 'Check their figures against ours',
  'reports.stmt.upload.title': 'Upload statement',
  'reports.stmt.upload.intro': 'Upload the commission statement a supplier sent you. Floxir matches each line to your invoices by invoice number and shows what agrees and what does not.',
  'reports.stmt.upload.pick': 'Choose a file',
  'reports.stmt.upload.formats': 'PDF, Excel (.xlsx) or CSV, up to 10 MB',
  'reports.stmt.upload.reading': 'Reading the file…',
  'reports.stmt.upload.lines.one': '1 line read',
  'reports.stmt.upload.lines.many': '{n} lines read',
  'reports.stmt.upload.unreadable.one': '1 line could not be read',
  'reports.stmt.upload.unreadable.many': '{n} lines could not be read',
  'reports.stmt.upload.fromImage': '{n} lines were read from a scanned image. Please check them.',
  'reports.stmt.upload.company': 'Company',
  'reports.stmt.upload.choose': 'Choose a company',
  'reports.stmt.upload.from': 'Period from',
  'reports.stmt.upload.to': 'to',
  'reports.stmt.upload.fromFile': 'Taken from the file. Please check.',
  'reports.stmt.upload.compare': 'Compare with Floxir',
  'reports.stmt.upload.comparing': 'Comparing…',
  'reports.stmt.upload.another': 'Choose another file',
  'reports.stmt.upload.badPeriod': 'The end of the period must not be before the start.',
  'reports.stmt.err.unsupported_type': 'This file is not a PDF, an Excel (.xlsx) file or a CSV file.',
  'reports.stmt.err.legacy_excel': 'Old Excel files (.xls) are not accepted. Save the file as .xlsx and try again.',
  'reports.stmt.err.macro_workbook': 'Excel files with macros are not accepted. Save a copy as .xlsx without macros.',
  'reports.stmt.err.zip_bomb': 'This Excel file is too large once opened.',
  'reports.stmt.err.too_large': 'The file is larger than 10 MB.',
  'reports.stmt.err.empty_file': 'The file is empty.',
  'reports.stmt.err.no_file': 'Choose a file first.',
  'reports.stmt.err.no_table': 'No table of invoices was found in this file.',
  'reports.stmt.err.no_lines': 'No invoice lines were found in this file.',
  'reports.stmt.err.too_many_lines': 'The file has too many lines (the limit is 5,000).',
  'reports.stmt.err.too_many_pages': 'The PDF has too many pages (the limit is 40).',
  'reports.stmt.err.too_long': 'The PDF holds too much text to read.',
  'reports.stmt.err.unreadable_pdf': 'This PDF could not be opened.',
  'reports.stmt.err.ai_unavailable': 'The PDF could not be read right now. Try again, or upload an Excel or CSV file.',
  'reports.stmt.err.too_many_uploads': 'Too many uploads in the last hour. Try again later.',
  'reports.stmt.err.generic': 'The statement could not be read. Try again.',
  'reports.stmt.err.compare': 'The comparison could not be made. Try again.',
  'reports.stmt.title': 'Statement',
  'reports.stmt.period': 'Period',
  'reports.stmt.file': 'File',
  'reports.stmt.uploadedOn': 'Uploaded',
  'reports.stmt.download': 'Download the original file',
  'reports.stmt.downloadFailed': 'The file could not be downloaded. Try again.',
  'reports.stmt.printedTotal': 'Total printed on the statement',
  'reports.stmt.notFound': 'This statement was not found.',
  'reports.stmt.group.agrees': 'Agrees',
  'reports.stmt.group.agrees.hint': 'Amount and commission match our invoice.',
  'reports.stmt.group.differs': 'Amount or rate differs',
  'reports.stmt.group.differs.hint': 'Both figures and the difference.',
  'reports.stmt.group.not_in_floxir': 'On their statement, not in Floxir',
  'reports.stmt.group.not_in_floxir.hint': 'No invoice of ours with this number.',
  'reports.stmt.group.not_on_statement': 'Possible underpayment',
  'reports.stmt.group.not_on_statement.hint': 'In Floxir with the payment term ended in this period, but not on their statement.',
  'reports.stmt.total.agrees': 'Commission',
  'reports.stmt.total.differs': 'Theirs {theirs} · ours {ours} · difference {diff}',
  'reports.stmt.total.not_in_floxir': 'Commission on their statement',
  'reports.stmt.total.not_on_statement': 'Commission we expect',
  'reports.stmt.lines.one': '1 line',
  'reports.stmt.lines.many': '{n} lines',
  'reports.stmt.fromImage': '{n} read from a scanned image',
  'reports.stmt.credits.one': '1 credit note is listed, not subtracted',
  'reports.stmt.credits.many': '{n} credit notes are listed, not subtracted',
  'reports.stmt.unconverted.one': '1 line has no exchange rate and is not in the total',
  'reports.stmt.unconverted.many': '{n} lines have no exchange rate and are not in the total',
  'reports.stmt.noRate.one': '1 more invoice belongs to a company with no rate. It is counted here, not added to the total.',
  'reports.stmt.noRate.many': '{n} more invoices belong to companies with no rate. They are counted here, not added to the total.',
  'reports.stmt.noRate.show': 'Show these invoices',
  'reports.stmt.empty': 'No lines in this group.',
  'reports.stmt.showAll': 'Show all {n} lines',
  'reports.stmt.col.invoice': 'Invoice',
  'reports.stmt.theirs': 'Theirs',
  'reports.stmt.ours': 'Ours',
  'reports.stmt.diff': 'Difference',
  'reports.stmt.commission': 'Commission',
  'reports.stmt.net': 'Net',
  'reports.stmt.rate': 'Rate',
  'reports.stmt.termEnd': 'Term ended',
  'reports.stmt.unreadable.title': 'Lines that could not be read',
  'reports.stmt.unreadable.hint': 'Never added to any total. Check them in the original file.',
  'reports.stmt.flag.credit_note': 'Credit note',
  'reports.stmt.flag.matched_by_number': 'Matched by the digits of the number',
  'reports.stmt.flag.other_supplier_record': 'Invoice is under another record of this company',
  'reports.stmt.flag.matches_two': 'Two of our invoices have this number',
  'reports.stmt.flag.duplicate_on_statement': 'Appears twice on the statement',
  'reports.stmt.flag.rate_conflict': 'We have two different rates for this company',
  'reports.stmt.flag.no_rate': 'No rate for this company',
  'reports.stmt.flag.other_period': 'Payment term ends outside this period',
  'reports.stmt.flag.no_invoice_number': 'No invoice number',
  'reports.stmt.flag.no_amount': 'No amount',
  'reports.stmt.flag.image': 'Read from an image',
  'reports.stmt.list.title': 'Statements you uploaded',
  'reports.stmt.list.open': 'Open',
  'reports.stmt.list.error': 'The list of statements could not be read.',
  'reports.stmt.list.result': '{agree} agree · difference {diff}',
  'reports.stmt.flag.term_assumed': 'Payment term assumed at 60 days',
  'reports.note.flagged.one': '1 invoice counts its total, which may include VAT',
  'reports.note.flagged.many': '{n} invoices count their total, which may include VAT',
  'reports.note.noNet.one': '1 invoice has no net value and is not counted',
  'reports.note.noNet.many': '{n} invoices have no net value and are not counted',
  'reports.note.noFx.one': '1 invoice could not be converted (no exchange rate)',
  'reports.note.noFx.many': '{n} invoices could not be converted (no exchange rate)',
  'reports.note.assumed.one': '1 invoice has a payment term assumed at 60 days',
  'reports.note.assumed.many': '{n} invoices have a payment term assumed at 60 days',
  'reports.note.uncertainDate.one': '1 invoice with an uncertain date',
  'reports.note.uncertainDate.many': '{n} invoices with an uncertain date',
  'reports.note.future.one': '1 future-dated invoice left out',
  'reports.note.future.many': '{n} future-dated invoices left out',
  'reports.note.ordersOlder': '{n} orders older than 180 days are not included',
  'reports.note.ordersNoValue': '{n} orders have no value that can be counted',
  'reports.forecast.late.one': 'Late, not yet invoiced: 1 order, {amount}',
  'reports.forecast.late.many': 'Late, not yet invoiced: {n} orders, {amount}',
  'reports.forecast.late.missing': '{n} of them have no value that can be counted',
  'reports.forecast.late.hint': 'Orders whose expected payment date has passed are not in the forecast.',
  'reports.note.ordersFuture': '{n} orders dated in the future are not included',
  'reports.note.forecastBasis': 'Expected = orders not yet invoiced from the last 180 days (invoice expected 30 days after the order, then 60 days of payment term) plus invoices still within their payment term, times the rate.',
  'reports.note.commissionBasis': 'Commission = net invoiced (without VAT, duties, freight and handling) of invoices whose payment term has ended, times the supplier\'s rate.',
  'reports.forecast.title': 'Commission forecast',
  'reports.forecast.expected': 'Expected commission',
  'reports.forecast.lateNoInvoice.one': 'Late, no invoice yet: 1 order, {amount}',
  'reports.forecast.lateNoInvoice.many': 'Late, no invoice yet: {n} orders, {amount}',
  'reports.forecast.withoutLate': 'Without them: {amount}',
  'reports.forecast.legend.late': 'Late, no invoice yet',
  'reports.archive.supplier': 'Supplier',
  'reports.who.orders': 'Orders',
  'reports.who.ordersNoValue': '{n} orders have no value',
  'reports.who.documents': 'Documents',
  'reports.who.doc.order': 'Orders',
  'reports.who.doc.confirmation': 'Confirmations',
  'reports.who.doc.packing_list': 'Packing lists',
  'reports.who.doc.invoice': 'Invoices',
  'reports.who.doc.delivery_note': 'Delivery notes',
  'reports.who.discrepancies': 'Discrepancies identified',
  'reports.who.late': 'Documents late · not in total',
  'reports.who.posWithoutInvoice': '{n} POs without invoice',
  'reports.who.prices': 'Price increases · not in total',
  'reports.who.col.orders': 'Orders',
  'reports.who.col.orderValue': 'Order value',
  'reports.who.col.invoiced': 'Invoiced',
  'reports.customers.without': 'Without a customer',
  'reports.customers.withoutNote': 'Orders without an invoice cannot be tied to a customer yet, so they are counted here.',
  'reports.disc.row.quantity_differs': 'Quantity differs',
  'reports.disc.row.missing_line_item': 'Missing line item',
  'reports.disc.row.confirmation_differs': 'Confirmation differs from the order',
  'reports.disc.notChecked': 'not checked yet',
  'reports.disc.group.invoice': 'Invoice',
  'reports.disc.group.order': 'Order and confirmation',
  'reports.forecast.pill.next_week': 'Next week',
  'reports.forecast.pill.next_month': 'Next month',
  'reports.forecast.pill.next_6_months': 'Next 6 months',
  'reports.forecast.pill.custom': 'Custom',
  'reports.forecast.col.share': 'Share',
  'reports.forecast.col.pos': 'POs',
  'reports.forecast.col.poCommission': 'PO commission',
  'reports.forecast.col.invoiceCommission': 'Invoice commission',
  'reports.forecast.others': 'Others',
  'reports.forecast.total': 'Total',
  'reports.forecast.byMonth': 'By month',
  'reports.forecast.byWeek': 'By week',
  'reports.forecast.byDay': 'By day',
  'reports.archive.wholeYear': 'Full year',
  'reports.archive.allSuppliers': 'All suppliers',
  'reports.archive.noDataYet': 'No orders in this period.',
  'reports.accountant.title': 'For the accountant',
  'reports.accountant.pdf': 'PDF',
  'reports.accountant.xlsx': 'Excel',
  'reports.accountant.csv': 'CSV',
  'reports.accountant.zip': 'Invoices ZIP',
  'reports.accountant.help': 'The orders with their Done date and close reason, or the invoice files of the period.',
  'reports.accountant.shorter': 'Choose a shorter period',
  'reports.accountant.failed': 'The file could not be made. Try again.',
  'reports.stmt.delete': 'Delete',
  'reports.stmt.delete.confirm': 'Delete this statement and its file for good? Only the owner can do this.',
  'reports.stmt.delete.yes': 'Yes, delete',
  'reports.stmt.delete.failed': 'Could not delete it. Nothing was changed.',
  'reports.stmt.creditsReduce': 'Credit notes reduce this by {amount}',
  'reports.orders.title': 'Order valorization',
  'reports.orders.help': 'The orders of a month or a year by order date, one table per supplier. Commission here is the order value × the rate; what is earned stays on Commissions. From 2026.',
  'reports.orders.by.month': 'By month',
  'reports.orders.by.year': 'By year',
  'reports.orders.month': 'Month',
  'reports.orders.year': 'Year',
  'reports.orders.col.order': 'Order',
  'reports.orders.col.supplier': 'Supplier',
  'reports.orders.col.quantity': 'Quantity',
  'reports.orders.total': 'Total',
  'reports.orders.grand': 'All suppliers: value · commission',
  'reports.orders.empty': 'No orders in this period.',
  'reports.forecast.months.6': '6 months',
  'reports.forecast.months.12': '12 months',
  'reports.forecast.openPos': 'Open POs',
  'reports.forecast.invoicesNotDue': 'Invoices not yet due',
  'reports.forecast.legend.po': 'Open orders',
  'reports.forecast.legend.invoice': 'Invoices',
  'reports.forecast.col.company': 'Company',
  'reports.forecast.col.openPos': 'Open POs',
  'reports.forecast.col.poValue': 'PO value',
  'reports.forecast.col.invoices': 'Invoices',
  'reports.forecast.col.invoiceValue': 'Invoice value',
  'reports.forecast.col.type': 'Type',
  'reports.forecast.col.number': 'Number',
  'reports.forecast.col.date': 'Date',
  'reports.forecast.col.customer': 'Customer',
  'reports.forecast.col.value': 'Value',
  'reports.forecast.col.commission': 'Commission',
  'reports.forecast.col.expected': 'Expected',
  'reports.forecast.type.po': 'Order',
  'reports.forecast.type.invoice': 'Invoice',
  'reports.forecast.docs': 'Every document behind the forecast',
  'reports.forecast.docsOf': 'Documents of {name}',
  'reports.forecast.allCompanies': 'All companies',
  'reports.forecast.empty': 'No documents in this period.',
  'reports.forecast.export.pdf': 'Export PDF',
  'reports.forecast.export.xlsx': 'Export Excel',
  'reports.forecast.export.csv': 'Export CSV',
  'reports.forecast.exportFailed': 'The file could not be made. Try again.',
  'reports.forecast.flag.past': 'Past its weeks',
  'reports.forecast.flag.partly': 'Partly invoiced',
  'reports.forecast.flag.differs': 'Differs from the order',
  'reports.forecast.flag.no_order': 'No order',
  'reports.forecast.flag.no_value': 'No value',
  'reports.forecast.flag.order_no_value': 'Order has no value',
  'reports.forecast.flag.assumed': 'term assumed',
  'reports.disc.title': 'Discrepancies',
  'reports.disc.identified': 'Discrepancies identified',
  'reports.disc.cases': '{n} cases',
  'reports.disc.cases.one': '1 case',
  'reports.disc.stage.invoice': 'Invoice',
  'reports.disc.stage.order': 'Order and confirmation',
  'reports.disc.stage.delivery': 'Delivery',
  'reports.disc.row.price_above_order': 'Price above order',
  'reports.disc.row.billed_above_delivered': 'Billed above delivered',
  'reports.disc.row.charge_not_ordered': 'Charge not ordered',
  'reports.disc.row.duplicate_invoice': 'Duplicate invoice',
  'reports.disc.row.vat_wrong': 'VAT wrong',
  'reports.disc.row.delivered_less': 'Delivered less than ordered',
  'reports.disc.orderMissing': 'Order missing',
  'reports.disc.cantCheck': '{amount} on these invoices can\'t be checked yet',
  'reports.disc.noRef': 'No order number on the invoice',
  'reports.disc.priceIncreases': 'Price increases',
  'reports.disc.priceIncreases.summary': '{n} items · +{amount} · not in the total',
  'reports.disc.priceIncreases.cap': '{n} price changes above +100% are not counted (probably a change of unit)',
  'reports.disc.note.duplicates': 'Duplicate invoices are shown with their amount but are not in the total: that money has not been paid, only billed twice.',
  'reports.disc.note.dates': '{n} cases use the invoice date, because the date a problem was found is only recorded from 16 October',
  'reports.disc.note.noAmount': '{n} cases have no amount and are in the counts but not in the total',
  'reports.suppliers.title': 'Suppliers',
  'reports.invoiced': 'Invoiced',
  'reports.commission': 'Commission',
  'reports.forecast': 'Commission forecast',
  'reports.problems': 'Problems now',
  'reports.problems.discrepancies': 'Discrepancies identified',
  'reports.problems.priceIncreases': 'Price increases',
  'reports.problems.documents': 'Documents late',
  'reports.documents.count.one': '1 document',
  'reports.documents.count.many': '{n} documents',
  'reports.suppliers.ranking': 'Suppliers',
  'reports.supplier.buyers': 'Customers they sell to',
  'reports.supplier.cases': 'Cases',
  'reports.cases.attention': 'Needs attention',
  'reports.cases.open': 'Open',
  'reports.cases.matched': 'Matched',
  'reports.cases.done': 'Done',
  'reports.supplier.missingInvoice': 'Invoices {n} · oldest {days} days',
  'reports.supplier.missingDelivery': 'Delivery notes {n} · oldest {days} days',
  'reports.supplier.rate': 'Rate {rate}%',
  'reports.customers.title': 'Customers',
  'reports.customers.ranking': 'Customers',
  'reports.customers.orderMissing': 'Order missing',
  'reports.customers.withoutCustomer': 'Without a customer: {amount} on {n} invoices',
  'reports.customers.withoutCustomerCases': 'Without a customer: {n}',
  'reports.customer.suppliers': 'Suppliers they buy from',
  'reports.customer.namedOn': 'Named on {name} invoices',
  'reports.archive.title': 'Archive',
  'reports.archive.past': 'Past periods',
  'reports.archive.col.period': 'Period',
  'reports.archive.col.commissions': 'Commissions',
  'reports.archive.col.discrepancies': 'Discrepancies identified',
  'reports.archive.col.closed': 'Cases closed',
  'reports.archive.col.pack': 'Full pack',
  'reports.archive.download': 'Download',
  'reports.archive.fullYear': '{year} (full year)',
  'reports.archive.closedNote': 'Cases closed counts completions recorded since {date}; periods before that show "—" because nothing was recorded.',
  'reports.archive.downloadFailed': 'The pack could not be made. Try again.',
  'reports.archive.yearOnYear': 'This year against last year',
  'reports.archive.change': 'Change',
  'reports.archive.sameLast': 'Same period {year}',
  'reports.archive.soFar': '{year} so far',
  'reports.archive.note': 'Commissions leave out suppliers without a rate.',
  'reports.archive.empty': 'No closed period yet.',
};

export const reportsAgentIt = {
  'reports.title': 'Report',
  'reports.card.commissions': 'Provvigioni',
  'reports.card.discrepancies': 'Discrepanze',
  'reports.card.forecast': 'Previsione provvigioni',
  'reports.card.suppliers': 'Fornitori',
  'reports.card.customers': 'Clienti',
  'reports.card.archive': 'Archivio',
  'reports.back': 'Indietro',
  'reports.loading': 'Caricamento…',
  'reports.error': 'Questo report non si può caricare ora.',
  'reports.retry': 'Riprova',
  'reports.notAgent': 'Questi report sono per le aziende agenti.',
  'reports.period.this_week': 'Questa settimana',
  'reports.period.this_month': 'Questo mese',
  'reports.period.this_year': 'Quest\'anno',
  'reports.period.custom': 'Personalizzato',
  'reports.period.next_week': 'Prossima settimana',
  'reports.period.next_month': 'Prossimo mese',
  'reports.period.next_6_months': 'Prossimi 6 mesi',
  'reports.period.from': 'Dal',
  'reports.period.to': 'Al',
  'reports.period.apply': 'Applica',
  'reports.period.bad': 'Scegli un inizio prima della fine.',
  'reports.week': 'Settimana {n}',
  'reports.byCompany': 'Per azienda',
  'reports.col.company': 'Azienda',
  'reports.col.share': 'Quota',
  'reports.col.rate': 'Aliquota',
  'reports.col.netInvoiced': 'Netto fatturato',
  'reports.col.netExpected': 'Netto atteso',
  'reports.col.commission': 'Provvigione',
  'reports.col.expected': 'Provvigione attesa',
  'reports.total': 'Totale',
  'reports.none': '—',
  'reports.noSupplier': 'Nessun fornitore identificato',
  'reports.others': 'Altri ({n})',
  'reports.showAll': 'Mostra tutte le {n} aziende',
  'reports.showFewer': 'Mostra meno',
  'reports.commission.note': 'Contata alla fine del termine di pagamento, quindi può differire dal fatturato di questo periodo.',
  'reports.disc.casesCol': 'pratiche',
  'reports.empty': 'Niente in questo periodo.',
  'reports.rateConflict': 'Due aliquote diverse',
  'reports.excludingNoRate.one': 'esclusi 1 fornitore senza aliquota',
  'reports.excludingNoRate.many': 'esclusi {n} fornitori senza aliquota',
  'reports.statement.title': 'Estratto provvigioni',
  'reports.statement.export': 'Esporta estratto',
  'reports.statement.hint': 'Un PDF per questa azienda, da inviare al fornitore per essere pagati',
  'reports.statement.failed': 'Non è stato possibile creare l\'estratto. Riprova.',
  'reports.chart.by.day': 'Per giorno',
  'reports.chart.by.week': 'Per settimana',
  'reports.chart.by.month': 'Per mese',
  'reports.stmt.card': 'Carica estratto',
  'reports.stmt.cardHint': 'Confronta le loro cifre con le nostre',
  'reports.stmt.upload.title': 'Carica estratto',
  'reports.stmt.upload.intro': 'Carica l\'estratto provvigioni che ti ha inviato un fornitore. Floxir abbina ogni riga alle tue fatture tramite il numero di fattura e mostra cosa corrisponde e cosa no.',
  'reports.stmt.upload.pick': 'Scegli un file',
  'reports.stmt.upload.formats': 'PDF, Excel (.xlsx) o CSV, fino a 10 MB',
  'reports.stmt.upload.reading': 'Lettura del file…',
  'reports.stmt.upload.lines.one': '1 riga letta',
  'reports.stmt.upload.lines.many': '{n} righe lette',
  'reports.stmt.upload.unreadable.one': '1 riga non leggibile',
  'reports.stmt.upload.unreadable.many': '{n} righe non leggibili',
  'reports.stmt.upload.fromImage': '{n} righe sono state lette da un\'immagine scansionata. Controllale.',
  'reports.stmt.upload.company': 'Azienda',
  'reports.stmt.upload.choose': 'Scegli un\'azienda',
  'reports.stmt.upload.from': 'Periodo dal',
  'reports.stmt.upload.to': 'al',
  'reports.stmt.upload.fromFile': 'Preso dal file. Controlla.',
  'reports.stmt.upload.compare': 'Confronta con Floxir',
  'reports.stmt.upload.comparing': 'Confronto in corso…',
  'reports.stmt.upload.another': 'Scegli un altro file',
  'reports.stmt.upload.badPeriod': 'La fine del periodo non può precedere l\'inizio.',
  'reports.stmt.err.unsupported_type': 'Questo file non è un PDF, un file Excel (.xlsx) o un CSV.',
  'reports.stmt.err.legacy_excel': 'I vecchi file Excel (.xls) non sono accettati. Salva il file come .xlsx e riprova.',
  'reports.stmt.err.macro_workbook': 'I file Excel con macro non sono accettati. Salva una copia come .xlsx senza macro.',
  'reports.stmt.err.zip_bomb': 'Questo file Excel è troppo grande una volta aperto.',
  'reports.stmt.err.too_large': 'Il file supera i 10 MB.',
  'reports.stmt.err.empty_file': 'Il file è vuoto.',
  'reports.stmt.err.no_file': 'Scegli prima un file.',
  'reports.stmt.err.no_table': 'In questo file non è stata trovata nessuna tabella di fatture.',
  'reports.stmt.err.no_lines': 'In questo file non sono state trovate righe di fattura.',
  'reports.stmt.err.too_many_lines': 'Il file ha troppe righe (il limite è 5.000).',
  'reports.stmt.err.too_many_pages': 'Il PDF ha troppe pagine (il limite è 40).',
  'reports.stmt.err.too_long': 'Il PDF contiene troppo testo da leggere.',
  'reports.stmt.err.unreadable_pdf': 'Non è stato possibile aprire questo PDF.',
  'reports.stmt.err.ai_unavailable': 'Al momento non è stato possibile leggere il PDF. Riprova, oppure carica un file Excel o CSV.',
  'reports.stmt.err.too_many_uploads': 'Troppi caricamenti nell\'ultima ora. Riprova più tardi.',
  'reports.stmt.err.generic': 'Non è stato possibile leggere l\'estratto. Riprova.',
  'reports.stmt.err.compare': 'Non è stato possibile fare il confronto. Riprova.',
  'reports.stmt.title': 'Estratto',
  'reports.stmt.period': 'Periodo',
  'reports.stmt.file': 'File',
  'reports.stmt.uploadedOn': 'Caricato',
  'reports.stmt.download': 'Scarica il file originale',
  'reports.stmt.downloadFailed': 'Non è stato possibile scaricare il file. Riprova.',
  'reports.stmt.printedTotal': 'Totale stampato sull\'estratto',
  'reports.stmt.notFound': 'Questo estratto non è stato trovato.',
  'reports.stmt.group.agrees': 'Corrisponde',
  'reports.stmt.group.agrees.hint': 'Importo e provvigione corrispondono alla nostra fattura.',
  'reports.stmt.group.differs': 'Importo o aliquota diversi',
  'reports.stmt.group.differs.hint': 'Entrambe le cifre e la differenza.',
  'reports.stmt.group.not_in_floxir': 'Nel loro estratto, non in Floxir',
  'reports.stmt.group.not_in_floxir.hint': 'Nessuna nostra fattura con questo numero.',
  'reports.stmt.group.not_on_statement': 'Possibile mancato pagamento',
  'reports.stmt.group.not_on_statement.hint': 'In Floxir con termine di pagamento scaduto in questo periodo, ma non nel loro estratto.',
  'reports.stmt.total.agrees': 'Provvigione',
  'reports.stmt.total.differs': 'Loro {theirs} · nostra {ours} · differenza {diff}',
  'reports.stmt.total.not_in_floxir': 'Provvigione nel loro estratto',
  'reports.stmt.total.not_on_statement': 'Provvigione attesa',
  'reports.stmt.lines.one': '1 riga',
  'reports.stmt.lines.many': '{n} righe',
  'reports.stmt.fromImage': '{n} lette da un\'immagine scansionata',
  'reports.stmt.credits.one': '1 nota di credito è elencata, non sottratta',
  'reports.stmt.credits.many': '{n} note di credito sono elencate, non sottratte',
  'reports.stmt.unconverted.one': '1 riga non ha un tasso di cambio e non è nel totale',
  'reports.stmt.unconverted.many': '{n} righe non hanno un tasso di cambio e non sono nel totale',
  'reports.stmt.noRate.one': '1 altra fattura appartiene a un\'azienda senza aliquota. È contata qui, non aggiunta al totale.',
  'reports.stmt.noRate.many': '{n} altre fatture appartengono ad aziende senza aliquota. Sono contate qui, non aggiunte al totale.',
  'reports.stmt.noRate.show': 'Mostra queste fatture',
  'reports.stmt.empty': 'Nessuna riga in questo gruppo.',
  'reports.stmt.showAll': 'Mostra tutte le {n} righe',
  'reports.stmt.col.invoice': 'Fattura',
  'reports.stmt.theirs': 'Loro',
  'reports.stmt.ours': 'Nostra',
  'reports.stmt.diff': 'Differenza',
  'reports.stmt.commission': 'Provvigione',
  'reports.stmt.net': 'Netto',
  'reports.stmt.rate': 'Aliquota',
  'reports.stmt.termEnd': 'Termine scaduto il',
  'reports.stmt.unreadable.title': 'Righe non leggibili',
  'reports.stmt.unreadable.hint': 'Mai aggiunte a nessun totale. Controllale nel file originale.',
  'reports.stmt.flag.credit_note': 'Nota di credito',
  'reports.stmt.flag.matched_by_number': 'Abbinata dalle cifre del numero',
  'reports.stmt.flag.other_supplier_record': 'La fattura è sotto un altro record di questa azienda',
  'reports.stmt.flag.matches_two': 'Due nostre fatture hanno questo numero',
  'reports.stmt.flag.duplicate_on_statement': 'Compare due volte nell\'estratto',
  'reports.stmt.flag.rate_conflict': 'Abbiamo due aliquote diverse per questa azienda',
  'reports.stmt.flag.no_rate': 'Nessuna aliquota per questa azienda',
  'reports.stmt.flag.other_period': 'Il termine di pagamento scade fuori da questo periodo',
  'reports.stmt.flag.no_invoice_number': 'Nessun numero di fattura',
  'reports.stmt.flag.no_amount': 'Nessun importo',
  'reports.stmt.flag.image': 'Letta da un\'immagine',
  'reports.stmt.list.title': 'Estratti caricati',
  'reports.stmt.list.open': 'Apri',
  'reports.stmt.list.error': 'Non è stato possibile leggere l\'elenco degli estratti.',
  'reports.stmt.list.result': '{agree} corrispondono · differenza {diff}',
  'reports.stmt.flag.term_assumed': 'Termine di pagamento presunto a 60 giorni',
  'reports.note.flagged.one': '1 fattura conta il suo totale, che può includere l\'IVA',
  'reports.note.flagged.many': '{n} fatture contano il loro totale, che può includere l\'IVA',
  'reports.note.noNet.one': '1 fattura non ha un valore netto e non è contata',
  'reports.note.noNet.many': '{n} fatture non hanno un valore netto e non sono contate',
  'reports.note.noFx.one': '1 fattura non si è potuta convertire (nessun tasso di cambio)',
  'reports.note.noFx.many': '{n} fatture non si sono potute convertire (nessun tasso di cambio)',
  'reports.note.assumed.one': '1 fattura ha un termine di pagamento ipotizzato a 60 giorni',
  'reports.note.assumed.many': '{n} fatture hanno un termine di pagamento ipotizzato a 60 giorni',
  'reports.note.uncertainDate.one': '1 fattura con data incerta',
  'reports.note.uncertainDate.many': '{n} fatture con data incerta',
  'reports.note.future.one': '1 fattura con data futura esclusa',
  'reports.note.future.many': '{n} fatture con data futura escluse',
  'reports.note.ordersOlder': '{n} ordini più vecchi di 180 giorni non sono inclusi',
  'reports.note.ordersNoValue': '{n} ordini non hanno un valore contabile',
  'reports.forecast.late.one': 'In ritardo, non ancora fatturato: 1 ordine, {amount}',
  'reports.forecast.late.many': 'In ritardo, non ancora fatturati: {n} ordini, {amount}',
  'reports.forecast.late.missing': '{n} di questi non hanno un valore contabile',
  'reports.forecast.late.hint': 'Gli ordini con la data di pagamento attesa già passata non sono nella previsione.',
  'reports.note.ordersFuture': '{n} ordini con data futura non sono inclusi',
  'reports.note.forecastBasis': 'Atteso = ordini non ancora fatturati degli ultimi 180 giorni (fattura attesa 30 giorni dopo l\'ordine, poi 60 giorni di termine di pagamento) più fatture ancora nel termine di pagamento, per l\'aliquota.',
  'reports.note.commissionBasis': 'Provvigione = netto fatturato (senza IVA, dazi, trasporto e movimentazione) delle fatture con termine di pagamento concluso, per l\'aliquota del fornitore.',
  'reports.forecast.title': 'Previsione provvigioni',
  'reports.forecast.expected': 'Provvigione attesa',
  'reports.forecast.lateNoInvoice.one': 'In ritardo, ancora senza fattura: 1 ordine, {amount}',
  'reports.forecast.lateNoInvoice.many': 'In ritardo, ancora senza fattura: {n} ordini, {amount}',
  'reports.forecast.withoutLate': 'Senza di essi: {amount}',
  'reports.forecast.legend.late': 'In ritardo, senza fattura',
  'reports.archive.supplier': 'Fornitore',
  'reports.who.orders': 'Ordini',
  'reports.who.ordersNoValue': '{n} ordini senza valore',
  'reports.who.documents': 'Documenti',
  'reports.who.doc.order': 'Ordini',
  'reports.who.doc.confirmation': 'Conferme',
  'reports.who.doc.packing_list': 'Packing list',
  'reports.who.doc.invoice': 'Fatture',
  'reports.who.doc.delivery_note': 'Documenti di trasporto',
  'reports.who.discrepancies': 'Discrepanze identificate',
  'reports.who.late': 'Documenti in ritardo · non nel totale',
  'reports.who.posWithoutInvoice': '{n} ordini senza fattura',
  'reports.who.prices': 'Aumenti di prezzo · non nel totale',
  'reports.who.col.orders': 'Ordini',
  'reports.who.col.orderValue': 'Valore ordini',
  'reports.who.col.invoiced': 'Fatturato',
  'reports.customers.without': 'Senza cliente',
  'reports.customers.withoutNote': 'Gli ordini senza fattura non possono ancora essere collegati a un cliente, quindi sono contati qui.',
  'reports.disc.row.quantity_differs': 'Quantità diversa',
  'reports.disc.row.missing_line_item': 'Riga mancante',
  'reports.disc.row.confirmation_differs': 'La conferma differisce dall’ordine',
  'reports.disc.notChecked': 'non ancora verificato',
  'reports.disc.group.invoice': 'Fattura',
  'reports.disc.group.order': 'Ordine e conferma',
  'reports.forecast.pill.next_week': 'Prossima settimana',
  'reports.forecast.pill.next_month': 'Prossimo mese',
  'reports.forecast.pill.next_6_months': 'Prossimi 6 mesi',
  'reports.forecast.pill.custom': 'Personalizzato',
  'reports.forecast.col.share': 'Quota',
  'reports.forecast.col.pos': 'Ordini',
  'reports.forecast.col.poCommission': 'Provvigione ordini',
  'reports.forecast.col.invoiceCommission': 'Provvigione fatture',
  'reports.forecast.others': 'Altri',
  'reports.forecast.total': 'Totale',
  'reports.forecast.byMonth': 'Per mese',
  'reports.forecast.byWeek': 'Per settimana',
  'reports.forecast.byDay': 'Per giorno',
  'reports.archive.wholeYear': 'Anno intero',
  'reports.archive.allSuppliers': 'Tutti i fornitori',
  'reports.archive.noDataYet': 'Nessun ordine in questo periodo.',
  'reports.accountant.title': 'Per il commercialista',
  'reports.accountant.pdf': 'PDF',
  'reports.accountant.xlsx': 'Excel',
  'reports.accountant.csv': 'CSV',
  'reports.accountant.zip': 'ZIP delle fatture',
  'reports.accountant.help': 'Gli ordini con data di chiusura e motivo, oppure i file delle fatture del periodo.',
  'reports.accountant.shorter': 'Scegli un periodo più breve',
  'reports.accountant.failed': 'Impossibile creare il file. Riprova.',
  'reports.stmt.delete': 'Elimina',
  'reports.stmt.delete.confirm': 'Eliminare questo estratto e il suo file in modo definitivo? Solo il titolare può farlo.',
  'reports.stmt.delete.yes': 'Sì, elimina',
  'reports.stmt.delete.failed': 'Impossibile eliminarlo. Non è stato cambiato nulla.',
  'reports.stmt.creditsReduce': 'Le note di credito riducono questo importo di {amount}',
  'reports.orders.title': 'Valorizzazione degli ordini',
  'reports.orders.help': 'Gli ordini di un mese o di un anno per data d’ordine, una tabella per fornitore. La provvigione qui è il valore dell’ordine × l’aliquota; quella maturata resta in Provvigioni. Dal 2026.',
  'reports.orders.by.month': 'Per mese',
  'reports.orders.by.year': 'Per anno',
  'reports.orders.month': 'Mese',
  'reports.orders.year': 'Anno',
  'reports.orders.col.order': 'Ordine',
  'reports.orders.col.supplier': 'Fornitore',
  'reports.orders.col.quantity': 'Quantità',
  'reports.orders.total': 'Totale',
  'reports.orders.grand': 'Tutti i fornitori: valore · provvigione',
  'reports.orders.empty': 'Nessun ordine in questo periodo.',
  'reports.forecast.months.6': '6 mesi',
  'reports.forecast.months.12': '12 mesi',
  'reports.forecast.openPos': 'Ordini aperti',
  'reports.forecast.invoicesNotDue': 'Fatture non ancora scadute',
  'reports.forecast.legend.po': 'Ordini aperti',
  'reports.forecast.legend.invoice': 'Fatture',
  'reports.forecast.col.company': 'Azienda',
  'reports.forecast.col.openPos': 'Ordini aperti',
  'reports.forecast.col.poValue': 'Valore ordini',
  'reports.forecast.col.invoices': 'Fatture',
  'reports.forecast.col.invoiceValue': 'Valore fatture',
  'reports.forecast.col.type': 'Tipo',
  'reports.forecast.col.number': 'Numero',
  'reports.forecast.col.date': 'Data',
  'reports.forecast.col.customer': 'Cliente',
  'reports.forecast.col.value': 'Valore',
  'reports.forecast.col.commission': 'Provvigione',
  'reports.forecast.col.expected': 'Prevista',
  'reports.forecast.type.po': 'Ordine',
  'reports.forecast.type.invoice': 'Fattura',
  'reports.forecast.docs': 'Tutti i documenti dietro la previsione',
  'reports.forecast.docsOf': 'Documenti di {name}',
  'reports.forecast.allCompanies': 'Tutte le aziende',
  'reports.forecast.empty': 'Nessun documento in questo periodo.',
  'reports.forecast.export.pdf': 'Esporta PDF',
  'reports.forecast.export.xlsx': 'Esporta Excel',
  'reports.forecast.export.csv': 'Esporta CSV',
  'reports.forecast.exportFailed': 'Impossibile creare il file. Riprova.',
  'reports.forecast.flag.past': 'Oltre le settimane',
  'reports.forecast.flag.partly': 'Fatturato in parte',
  'reports.forecast.flag.differs': 'Diversa dall’ordine',
  'reports.forecast.flag.no_order': 'Senza ordine',
  'reports.forecast.flag.no_value': 'Senza valore',
  'reports.forecast.flag.order_no_value': 'Ordine senza valore',
  'reports.forecast.flag.assumed': 'termine ipotizzato',
  'reports.disc.title': 'Discrepanze',
  'reports.disc.identified': 'Discrepanze individuate',
  'reports.disc.cases': '{n} pratiche',
  'reports.disc.cases.one': '1 pratica',
  'reports.disc.stage.invoice': 'Fattura',
  'reports.disc.stage.order': 'Ordine e conferma',
  'reports.disc.stage.delivery': 'Consegna',
  'reports.disc.row.price_above_order': 'Prezzo sopra l\'ordine',
  'reports.disc.row.billed_above_delivered': 'Fatturato sopra il consegnato',
  'reports.disc.row.charge_not_ordered': 'Addebito non ordinato',
  'reports.disc.row.duplicate_invoice': 'Fattura duplicata',
  'reports.disc.row.vat_wrong': 'IVA errata',
  'reports.disc.row.delivered_less': 'Consegnato meno dell\'ordinato',
  'reports.disc.orderMissing': 'Ordine mancante',
  'reports.disc.cantCheck': '{amount} su queste fatture non si può ancora verificare',
  'reports.disc.noRef': 'Nessun numero d\'ordine sulla fattura',
  'reports.disc.priceIncreases': 'Aumenti di prezzo',
  'reports.disc.priceIncreases.summary': '{n} articoli · +{amount} · non nel totale',
  'reports.disc.priceIncreases.cap': '{n} variazioni di prezzo oltre +100% non sono contate (probabile cambio di unità)',
  'reports.disc.note.duplicates': 'Le fatture duplicate sono mostrate con il loro importo ma non sono nel totale: quel denaro non è stato pagato, solo fatturato due volte.',
  'reports.disc.note.dates': '{n} pratiche usano la data della fattura, perché la data in cui un problema è stato trovato è registrata solo dal 16 ottobre',
  'reports.disc.note.noAmount': '{n} pratiche non hanno un importo: sono nei conteggi ma non nel totale',
  'reports.suppliers.title': 'Fornitori',
  'reports.invoiced': 'Fatturato',
  'reports.commission': 'Provvigione',
  'reports.forecast': 'Previsione provvigioni',
  'reports.problems': 'Problemi ora',
  'reports.problems.discrepancies': 'Discrepanze individuate',
  'reports.problems.priceIncreases': 'Aumenti di prezzo',
  'reports.problems.documents': 'Documenti in ritardo',
  'reports.documents.count.one': '1 documento',
  'reports.documents.count.many': '{n} documenti',
  'reports.suppliers.ranking': 'Fornitori',
  'reports.supplier.buyers': 'Clienti a cui vendono',
  'reports.supplier.cases': 'Pratiche',
  'reports.cases.attention': 'Da controllare',
  'reports.cases.open': 'Aperte',
  'reports.cases.matched': 'Abbinate',
  'reports.cases.done': 'Chiuse',
  'reports.supplier.missingInvoice': 'Fatture {n} · la più vecchia {days} giorni',
  'reports.supplier.missingDelivery': 'Bolle di consegna {n} · la più vecchia {days} giorni',
  'reports.supplier.rate': 'Aliquota {rate}%',
  'reports.customers.title': 'Clienti',
  'reports.customers.ranking': 'Clienti',
  'reports.customers.orderMissing': 'Ordine mancante',
  'reports.customers.withoutCustomer': 'Senza cliente: {amount} su {n} fatture',
  'reports.customers.withoutCustomerCases': 'Senza cliente: {n}',
  'reports.customer.suppliers': 'Fornitori da cui comprano',
  'reports.customer.namedOn': 'Indicato sulle fatture di {name}',
  'reports.archive.title': 'Archivio',
  'reports.archive.past': 'Periodi passati',
  'reports.archive.col.period': 'Periodo',
  'reports.archive.col.commissions': 'Provvigioni',
  'reports.archive.col.discrepancies': 'Discrepanze individuate',
  'reports.archive.col.closed': 'Pratiche chiuse',
  'reports.archive.col.pack': 'Pacchetto completo',
  'reports.archive.download': 'Scarica',
  'reports.archive.fullYear': '{year} (anno intero)',
  'reports.archive.closedNote': 'Le pratiche chiuse contano i completamenti registrati dal {date}; i periodi precedenti mostrano "—" perché non era stato registrato nulla.',
  'reports.archive.downloadFailed': 'Non è stato possibile creare il pacchetto. Riprova.',
  'reports.archive.yearOnYear': 'Quest\'anno contro l\'anno scorso',
  'reports.archive.change': 'Variazione',
  'reports.archive.sameLast': 'Stesso periodo {year}',
  'reports.archive.soFar': '{year} finora',
  'reports.archive.note': 'Le provvigioni escludono i fornitori senza aliquota.',
  'reports.archive.empty': 'Nessun periodo chiuso finora.',
};
